import React, {useLayoutEffect, useRef, useState} from "react";
import {useSpring, animated} from '@react-spring/web';

import './style.css'

const Collapse = ({isOpen, children}) => {
  const ref = useRef(null);
  const [contentHeight, setContentHeight] = useState(0);
  const [shouldRender, setShouldRender] = useState(isOpen);


  useLayoutEffect(() => {
    if (isOpen) {
      setShouldRender(true); // показать контент перед анимацией
    }
    if (ref.current) {
      setContentHeight(ref.current.scrollHeight);
    }
  }, [isOpen, ref.current]);

  const animation = useSpring({
    height: isOpen ? contentHeight : 0,
    opacity: isOpen ? 1 : 0,
    config: isOpen
      ? {tension: 210, friction: 20} // для открытия: пружина с отскоком
      : {duration: 200},
    onRest: () => {
      if (!isOpen) {
        setShouldRender(false); // скрыть полностью после анимации
      }
    },
  });

  return (
    <animated.div ref={ref} style={animation} className={shouldRender ? 'collapse-open' : 'collapse-close'}>
      {children}
    </animated.div>
  )
};

export default Collapse